import React from "react";
import { UserConfigurationPersistence } from "@rebasepro/cms-types";

export const UserConfigurationPersistenceContext = React.createContext<UserConfigurationPersistence | undefined>(undefined);
